var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"height":"200px","width":"350px","id":"signature-tool"}})
}
var staticRenderFns = []

export { render, staticRenderFns }